var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgFileDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EFEFEF",
    fillRule: "nonzero",
    d: "M0 0h120v120H0z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B5D100",
    fillOpacity: 0.3,
    d: "M40.8 36h14.4v12H40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 57h31.2M60 40.8h10.26M60 46.8h18.635M48 64.2h31.2M48 71.4h31.2M40.8 57h2.4m-2.4 7.2h2.4m-2.4 7.2h2.4m-7.6-42.6h38.8l12 12.48V89.2a2 2 0 0 1-2 2H35.6a2 2 0 0 1-2-2V30.8a2 2 0 0 1 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M74.4 28.8v9.6a2.4 2.4 0 0 0 2.4 2.4h9.6l-12-12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.2 83.4 3-3 3 3 3-3 3 3 3-3 3 3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgFileDoc);
export default __webpack_public_path__ + "static/media/img-file-doc.e5fe180c0b237a3a8655827ba213b616.svg";
export { ForwardRef as ReactComponent };